import React from "react";
import { FormattedMessage } from "react-intl";
import "./IdCardGuidelines.scss";

type Props = { side: string };

const IdCardGuidelines: React.FC<Props> = ({ side }) => {
  return (
    <div className="id-card">
      <ul>
        <li>
          <FormattedMessage
            id="account-verification-id-eea-countries"
            defaultMessage="National identity cards may be issued in some European Economic Area (EEA) countries. We can't accept other citizen cards or residence permits."
          />
        </li>
        <li>
          <FormattedMessage
            id="account-verification-guidelines-full-name"
            defaultMessage="Matches the full name you provided."
          />
        </li>
        <li>
          <FormattedMessage
            id="account-verification-guidelines-date-of-birth"
            defaultMessage="Matches your date of birth."
          />
        </li>
        <li>
          <FormattedMessage
            id="account-verification-guidelines-valid"
            defaultMessage="Hasn't expired and is still valid for use."
          />
        </li>
      </ul>
    </div>
  );
};

export default IdCardGuidelines;
